<template>

    <div class="hpanel hviolet">
        <div class="panel-heading hbuilt">
            Viajes
        </div>
        <div class="panel-body" style="padding: 15px;">
            <div class="m-b-md">
                <div class="m-b-sm">
                    <button class="btn btn-default" type="button" data-toggle="collapse" data-target="#rideListFilters"
                        aria-expanded="false" @click="toggleFilter" aria-controls="rideListFilters">
                        Filtros
                        <i :class="'fa fa-caret-' + (filterFlag ? 'down' : 'up')"></i>
                    </button>

                    <button class="btn btn-primary btn-outline pull-right" @click="downloadExcel"> Descargar
                        <i class="fa fa-file-excel-o"></i></button>
                    <button class="btn btn-primary btn-outline pull-right" style="margin-right: 10px" @click="search"> Refrescar
                        <i class="fa fa-refresh"></i></button>
                </div>
                <div class="collapse" id="rideListFilters">
                    <div class="form">
                        <div class="row">
                            <div v-if="!isHotel" class="col-md-3 form-group">
                                <label>Hotel</label>
                                <custom-input tipo="select" :field="$v.filters.hotel" :items="hotels" />
                            </div>
                            <div class="col-md-3 form-group">
                                <label>Estado</label>
                                <custom-input tipo="select" :field="$v.filters.status" :items="statuses" />
                            </div>
                            <div class="col-md-3 form-group">
                                <label class="control-label">Fecha Inicio</label>
                                <custom-input tipo="date" :field="$v.filters.startDate" :init="false" />
                            </div>
                            <div class="col-md-3 form-group">
                                <label class="control-label">Fecha Fin</label>
                                <custom-input tipo="date" :field="$v.filters.endDate" :init="false" />
                            </div>
                            <div class="col-md-3 form-group">
                                <label class="control-label">Código de huésped</label>
                                <custom-input tipo="text" :field="$v.filters.guestCode" />
                            </div>
                            <div class="col-md-3 form-group">
                                <label class="control-label">Correo de huésped</label>
                                <custom-input tipo="text" :field="$v.filters.guestEmail" />
                            </div>
                        </div>
                        <div class="row text-center">
                            <div class="col-md-12">
                                <button type="button" class="btn btn-default" @click="clear">
                                    Limpiar filtros
                                    <i class="fa fa-trash-o"></i>
                                </button>
                                <button type="button" class="btn btn-primary" @click="search">
                                    Aplicar filtros
                                    <i class="fa fa-search"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="row">
                <div class="hpanel filter-item" v-for="o in data" :key="o.id">
                    <a @click="onSelectRide(o.id)">
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-xs-7 ride_det_1">
                                    <h4 style="">{{ o.guestName }}</h4>
                                    <ride-status-badges :status="o.status" />
                                    <div>
                                        <div class="pull-left">
                                            <img src="@/assets/images/orig-dest.png"
                                                style="margin-top: 3px; margin-right: 10px;" />
                                        </div>
                                        <div>
                                            <p>{{ o.origAddress }}</p>
                                            <p>{{ o.destAddress }} </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-xs-4 pull-right text-right ride_det_2">
                                    <span class="date">{{ o.scheduledAt }}</span>
                                    <h4 v-usd="o.total"></h4>
                                </div>
                            </div>
                        </div>
                    </a>
                    <transition name="custom-classes-transition" enter-active-class=" animated  fadeIn"
                        leave-active-class="collapse">
                        <div v-show="isOpen(o.id)" class="panel-body ride_list">
                            <div class="row" v-if="o.notified && o.status === 1">
                                <div class="icons-box pull-right" style="padding: 0 20px">
                                    <a target="_blank" :href="`${webUrl}/status/${o.id}`" class="btn btn-default">
                                        Ver viaje <i class="pe-7s-link" style="    font-size: 15px;"></i>
                                    </a>
                                    <button @click="notify(o.id)" class="btn btn-default">
                                        Notificar <i class="pe-7s-bell" style="    font-size: 15px;"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-2">
                                    <span>Hora recojo</span>
                                    <h4>{{ o.scheduledAtHour }}</h4>
                                </div>
                                <div class="col-xs-2">
                                    <span>Hora llegada</span>
                                    <h4 v-value-dash="o.finishedAtHour"></h4>
                                </div>
                                <div class="col-xs-2">
                                    <span>Distancia est.</span>
                                    <h4 v-kms="o.distanceEst"></h4>
                                </div>
                                <div class="col-xs-2">
                                    <span>Duración est.</span>
                                    <h4 v-dur="o.durationEst"></h4>
                                </div>
                                <div class="col-xs-2">
                                    <span>Duración real</span>
                                    <h4 v-dur="o.durationReal"></h4>
                                </div>
                                <div class="col-xs-2">
                                    <span>Tipo</span>
                                    <h4>{{ getVehicleType(o.vehicleType) }}</h4>
                                </div>
                            </div>
                            <hr v-if="o.vehicleId" />
                            <div class="row" v-if="o.vehicleId">
                                <div class="col-xs-2">
                                    <span>Conductor</span>
                                    <h4>{{ o.driverName }}</h4>
                                </div>
                                <div class="col-xs-2">
                                    <span>Marca</span>
                                    <h4>{{ o.vehicleBrand }}</h4>
                                </div>
                                <div class="col-xs-2">
                                    <span>Color</span>
                                    <h4>{{ getColor(o.vehicleColor) }}</h4>
                                </div>
                                <div class="col-xs-2">
                                    <span>Placa</span>
                                    <h4>{{ o.vehiclePlate }}</h4>
                                </div>
                                <div class="col-xs-2">
                                    <span>Celular</span>
                                    <h4>{{ o.driverPhone }}</h4>
                                </div>
                                <div class="col-xs-2"><img :src="o.driverPic" class="img-circle img-small" />
                                </div>
                            </div>
                            <hr v-if="o.fromAirport" />
                            <div class="row" v-if="o.fromAirport">
                                <div class="col-xs-2" v-if="o.flightAirline">
                                    <span>Aerolínea</span>
                                    <h4>{{ o.flightAirline }}</h4>
                                </div>
                                <div class="col-xs-2" v-if="o.flightNumber">
                                    <span>Vuelo</span>
                                    <h4>{{ o.flightNumber }}</h4>
                                </div>
                                <div class="col-xs-2" v-if="o.flightOrigin">
                                    <span>Procedencia</span>
                                    <h4>{{ o.flightOrigin }}</h4>
                                </div>
                                <div class="col-xs-2" v-if="o.flightGate">
                                    <span>Puerta Emb.</span>
                                    <h4>{{ o.flightGate }}</h4>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
            <paginator :total-elements="totalElements" :page-number="pageNumber" :total-pages="totalPages"
                style="margin: 10px 0 0 0 " :change-page="changePage" />
        </div>
    </div>
</template>

<script>

import CustomInput from '../common/CustomInput.vue'
import RideStatusBadges from './RideStatusBadges'
import { colorList, rideStatusList, vehicleTypeList } from '../../util/selectOptions'
import { email } from 'vuelidate/lib/validators'
import firebase from '../../services/firebase'
import { dateGreaterThan } from '../../directives/customValidations'
import { paginationMixin } from '../../util/paginationMixin'
import { filterMixin } from '../../util/filterMixin'
import RideService from "../../services/RideService";
import HotelService from "../../services/HotelService";
import fileDownload from 'js-file-download';
import { mapGetters } from 'vuex'
import * as moment from 'moment';
import Alert from "../../util/alert";
import Util from '../../util/util';
import { Errors } from "../../constants";

export default {
    mixins: [
        paginationMixin,
        filterMixin
    ],
    components: { CustomInput, RideStatusBadges },
    data: () => ({
        data: [],
        hotels: [],
        statuses: rideStatusList,
        selectedRideId: null,
        webUrl: process.env.WEB_URL,
        filters: {
            hotel: null,
            status: null,
            startDate: null,
            endDate: null,
            guestCode: null,
            guestEmail: null
        }
    }),
    computed: {
        ...mapGetters([
            'isHotel',
        ]),
    },
    validations: {
        filters: {
            hotel: {},
            status: {},
            startDate: {},
            endDate: { dateGreaterThan: dateGreaterThan('startDate') },
            guestCode: {},
            guestEmail: { email }
        }
    },
    methods: {
        async init() {
            const self = this;
            await this.getData();
            if (!this.isHotel) {
                this.hotels = [];
                const hotelsData = (await HotelService.listAllHotels()).data.payload;
                hotelsData.forEach(it => {
                    self.hotels.push({ key: it.id, value: it.name })
                });
            }
        },
        search() {
            this.$v.$touch();
            if (this.$v.$error) return;
            const self = this;

            const data = {
                ...self.filters,
                hotelId: self.filters.hotel ? self.filters.hotel.key : null,
                status: self.filters.status ? self.filters.status.key : null,
            };

            data.startDate = self.filters.startDate ? moment(self.filters.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
            data.endDate = self.filters.endDate ? moment(self.filters.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
            self.getData(data)
        },
        clear() {
            const self = this;
            self.filters.hotel = null;
            self.filters.status = null;
            self.filters.startDate = null;
            self.filters.endDate = null;
            self.filters.guestCode = null;
            self.filters.guestEmail = null;
            self.$v.$reset();
        },
        onSelectRide(rideId) {
            const self = this;
            if (rideId !== self.selectedRideId) {
                self.loadDriverPic(rideId);
                self.selectedRideId = rideId;
            } else
                self.selectedRideId = null;
        },
        getColor(colorId) {
            if (colorId) {
                const col = colorList.filter((c) => {
                    return c.key === colorId.toLowerCase();
                });
                if (col && col.length > 0)
                    return col[0].value;
            }
        },
        getVehicleType(type) {
            if (type) {
                const col = vehicleTypeList.filter((c) => {
                    return c.key === type;
                });
                if (col && col.length > 0)
                    return col[0].value;
            }
        },
        isOpen(rideId) {
            return rideId === this.selectedRideId;
        },
        loadDriverPic(rideId) {
            const self = this;
            const ride = self.data.find(c => c.id === rideId);
            if (ride && !ride.picLoaded && ride.driverPicUrl) {
                const index = self.data.indexOf(ride);
                ride.picLoaded = true;
                const storageRef = firebase.getStorage().ref();
                storageRef.child(ride.driverPicUrl)
                    .getDownloadURL().then(function (url) {
                        ride.driverPicFullPath = url;
                        self.$set(self.data, index, ride);
                    });
            }
        },
        downloadExcel() {
            const self = this;
            Alert.alert("Generando Excel", "Se está generando el archivo, por favor no refresque la página.");
            const data = {
                ...self.filters,
                hotelId: self.filters.hotel ? self.filters.hotel.key : null,
                status: self.filters.status ? self.filters.status.key : null,
            };
            RideService.downloadExcel(data).then(response => {
                Alert.mensajeExito("Se generó el archivo Excel correctamente.");
                fileDownload(response.data, Util.getFileName(response));
            }).catch((err) => {
                console.error(err);
                Alert.mensajeError(Errors.SERVER_ERROR);
            });
        },
        notify(id) {
            RideService.notify(id).then(() => {
                Alert.mensajeExito("Se notificó el viaje pendiente a los conductores correctamente.");
            }).catch((err) => {
                console.error(err);
                Alert.mensajeError("Hubo un error al notificar el viaje a los conductores");
            });
        },
        async getData(params = {}, page = 1) {
            params.page = page - 1;
            params.size = this.pageSize;
            this.params = params;
            this.loading = true;
            const payload = (await RideService.filterRides(params)).data.payload;
            this.data = payload.content;
            this.totalPages = payload.totalPages;
            this.totalElements = payload.totalElements;
            this.pageNumber = payload.number + 1;
            this.loading = false;
        },
    },
    async mounted() {
        const self = this;
        self.init();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ride/RideList.vue